/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface AssociatedResultTemplateUpdateDTO
 */
export interface AssociatedResultTemplateUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplateUpdateDTO
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssociatedResultTemplateUpdateDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof AssociatedResultTemplateUpdateDTO
     */
    type?: LearningCompetenceTypeEnum;
}

export function AssociatedResultTemplateUpdateDTOFromJSON(json: any): AssociatedResultTemplateUpdateDTO {
    return AssociatedResultTemplateUpdateDTOFromJSONTyped(json, false);
}

export function AssociatedResultTemplateUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociatedResultTemplateUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
    };
}

export function AssociatedResultTemplateUpdateDTOToJSON(value?: AssociatedResultTemplateUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
    };
}

